import { HttpClient } from "@angular/common/http";
import { environment as env } from "../../../../../environments/environment.prod";
import { Injectable } from "@angular/core";
import { AbstractService } from "app/services/abstract.service";
import { Observable } from "rxjs";
import {
  IPagination,
  IPaginationResult,
  IRequestResult,
} from "app/common/interfaces";
import {
  andWhere,
  buildQuery,
  CombinedFilter,
  noop,
  Ops,
  orderBy,
  OrderVariant,
  orWhere,
  page,
  select,
  where,
} from "@albatrosdeveloper/ave-utils-npm/lib/utils/query.util";
import NotificationAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/notification/notification/notification.entity";
import { ICreateNotification, IUpdateNotification } from "./interfaces/notification.service";

const apiUrl = env.API_AVE_NOTIFICATION;
const moduleName = "notification";

@Injectable({
  providedIn: "root",
})
export class NotificationService extends AbstractService<
  NotificationAttributes,
  ICreateNotification,
  IUpdateNotification
> {

  constructor(http: HttpClient) {
    super(apiUrl, moduleName, http);
  }

  /**
   * List
   * @param filter CombinedFilter of related entity - NotificationAttributes
   * @returns Data list
   */
  getAllPaginate(
    options: IPagination<NotificationAttributes>,
    other?: {
      statusIds?: number[],
      companyIds?: number[],
      distributionChainIds?: number[],
      salesOfficeIds?: number[],
      notificationGroupIds?: number[],
      notificationMemberIds?: number[],
    }
  ): Observable<IPaginationResult<NotificationAttributes>> {
    const query = buildQuery<NotificationAttributes>(
      where("_deleted", Ops.eq(false)),
      other && other?.statusIds?.length ? where("statusId", Ops.in(...other?.statusIds)) : noop(),
      other && other?.companyIds?.length ? where("company.id" as keyof NotificationAttributes, Ops.in(...other?.companyIds)) : noop(),
      other && other?.distributionChainIds?.length ? where("distributionChain.id" as keyof NotificationAttributes, Ops.in(...other?.distributionChainIds)) : noop(),
      other && other?.salesOfficeIds?.length ? where("salesOffice.id" as keyof NotificationAttributes, Ops.in(...other?.salesOfficeIds)) : noop(),
      other && other?.notificationGroupIds?.length ? where("notificationGroup.id" as keyof NotificationAttributes, Ops.in(...other?.notificationGroupIds)) : noop(),
      other && other?.notificationMemberIds?.length ? where("notificationMember.id" as keyof NotificationAttributes, Ops.in(...other?.notificationMemberIds)) : noop(),
      orderBy(
        options.sort ?? "name",
        options.sortDirection == "ASC" ? OrderVariant.Asc : OrderVariant.Desc
      ),
      page(options.currentPage ?? 1, options.limitPerPage ?? 100)
    );

    const API_URL: string =
      apiUrl +
      `api/${moduleName}/withCount?filter=${encodeURIComponent(JSON.stringify(query))}`;
    return this.http.get<IPaginationResult<NotificationAttributes>>(API_URL);
  }
}
